function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Emoji_MyHeartandYourHeart");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "P_St_A",
  transform: "translate(-581.000000, -483.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(409.000000, 473.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Emoji_MyHeartandYourHeart",
  transform: "translate(173.000000, 11.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "color",
  fill: "#C92DB4",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.096,8.756181 C12.096,6.9794676 10.6557066,5.5391742 8.8789932,5.5391742 C7.6556718,5.5391742 6.5920554,6.2221068 6.048,7.2273978 C5.5039824,6.2221068 4.4403282,5.5391742 3.2170068,5.5391742 C1.4402934,5.5391742 1.34292577e-15,6.9794676 1.34292577e-15,8.756181 C1.34292577e-15,9.5205348 0.2677374,10.2216492 0.7129836,10.773567 L0.7118874,10.7744364 L6.048,17.388 L11.3841126,10.7744364 L11.3830164,10.773567 C11.8282626,10.2216114 12.096,9.520497 12.096,8.756181 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.9,1.7090514 C18.9,0.7651476 18.1348524,0 17.1909486,0 C16.5410532,0 15.9760188,0.3628044 15.687,0.8968806 C15.3979812,0.3628044 14.8329468,0 14.1830514,0 C13.2391476,0 12.474,0.7651476 12.474,1.7090514 C12.474,2.115099 12.6162414,2.4875802 12.852756,2.7807948 L12.852189,2.7812484 L15.687,6.2946828 L18.521811,2.7812484 L18.521244,2.7807948 C18.7577586,2.4875802 18.9,2.115099 18.9,1.7090514 Z",
  id: "Path"
})), /*#__PURE__*/React.createElement("g", {
  id: "line",
  strokeWidth: 0.756
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.2562054,3.2856894 C4.8073284,2.0774124 7.0085358,1.323 9.45,1.323 C9.7110468,1.323 9.9693342,1.3316184 10.2243708,1.348515",
  id: "Path",
  stroke: "#FFFFFF",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.8697222,6.5247714 C19.0131732,6.9788628 19.089,7.4519298 19.089,7.938 C19.089,11.2372218 15.5958264,13.9381452 11.1737556,14.1602202",
  id: "Path",
  stroke: "#FFFFFF",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.096,8.756181 C12.096,6.9794676 10.6557066,5.5391742 8.8789932,5.5391742 C7.6556718,5.5391742 6.5920554,6.2221068 6.048,7.2273978 C5.5039824,6.2221068 4.4403282,5.5391742 3.2170068,5.5391742 C1.4402934,5.5391742 1.34292577e-15,6.9794676 1.34292577e-15,8.756181 C1.34292577e-15,9.5205348 0.2677374,10.2216492 0.7129836,10.773567 L0.7118874,10.7744364 L6.048,17.388 L11.3841126,10.7744364 L11.3830164,10.773567 C11.8282626,10.2216114 12.096,9.520497 12.096,8.756181 Z",
  id: "Path",
  stroke: "#000000",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.9,1.7090514 C18.9,0.7651476 18.1348524,0 17.1909486,0 C16.5410532,0 15.9760188,0.3628044 15.687,0.8968806 C15.3979812,0.3628044 14.8329468,0 14.1830514,0 C13.2391476,0 12.474,0.7651476 12.474,1.7090514 C12.474,2.115099 12.6162414,2.4875802 12.852756,2.7807948 L12.852189,2.7812484 L15.687,6.2946828 L18.521811,2.7812484 L18.521244,2.7807948 C18.7577586,2.4875802 18.9,2.115099 18.9,1.7090514 Z",
  id: "Path",
  stroke: "#000000",
  strokeLinejoin: "round"
}))))));

var SvgHearts = function SvgHearts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "19px",
    viewBox: "0 0 21 19",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHearts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hearts.12fe759d.svg";
export { ForwardRef as ReactComponent };